module.exports = __webpack_public_path__ + "static/media/download.65e04b02.svg";